import React, { ElementType, forwardRef, ReactNode } from 'react'
import classNames from 'classnames'

interface InputGroupProps {
    className?: string
    size?: 'sm' | 'lg'
    tag?: ElementType
    children?: ReactNode
}

export const InputGroupContext = React.createContext({ insideInputGroup: false })

export const InputGroup = forwardRef<HTMLDivElement, InputGroupProps>(({
    className,
    tag: Tag = 'div',
    size,
    children,
    ...otherProps
}, ref) => {
    const classes = classNames('input-group', className, {
        [`input-group-${size}`]: size
    })

    return (
        <InputGroupContext.Provider value={{ insideInputGroup: true }}>
            <Tag
                ref={ref}
                {...otherProps}
                className={classes}
            >
                {children}
            </Tag>
        </InputGroupContext.Provider>
    )
})
